module.exports = require("express");


/*****************
 ** WEBPACK FOOTER
 ** external "express"
 ** module id = 4
 ** module chunks = 0
 **/